import React, { Component, Fragment } from 'react';
import { WITHIN_RAD, MSG_OK, MSG_ERR } from '../App';
import axios from 'axios';

const haversine = require('haversine')

const INCIDENT_TYPES = [
    { value: 'CLOSED',   label: 'Cerrado permanentemente' },
    { value: 'MOVED',    label: 'Se mudó de dirección' },
    { value: 'RENAMED',  label: 'Cambió de nombre' },
    { value: 'ACCESS',   label: 'Sin acceso / entrada bloqueada' },
    { value: 'OTHER',    label: 'Otro' },
];


class ActivateLoc extends Component {

    state = {
        showReport: false,
        incidentType: 'OTHER',
        incidentNotes: '',
        submitting: false,
    }

    componentDidMount() {
        const { GetHeadingpoint } = this.props;
        GetHeadingpoint();
    }

    componentWillUnmount() {}

    submitIncident = async () => {
        const { tasks_by_loc, selected_loc, displayMsg } = this.props;
        const { incidentType, incidentNotes } = this.state;
        const loc = tasks_by_loc[selected_loc];

        // loc_scope is the Location pk stored in the task
        const locationId = loc.loc_scope;
        const collabId = localStorage.getItem('colId');

        if (!locationId || !collabId) {
            displayMsg("Error: datos de ubicación no disponibles.", MSG_ERR);
            return;
        }

        this.setState({ submitting: true });

        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`,
        };

        try {
            await axios.post('/api/location_incidents/', {
                location: locationId,
                reported_by: parseInt(collabId),
                incident_type: incidentType,
                notes: incidentNotes,
            }, { headers });

            displayMsg("Reporte enviado. ¡Gracias!", MSG_OK);
            this.setState({ showReport: false, incidentType: 'OTHER', incidentNotes: '', submitting: false });
        } catch (err) {
            console.error(err.response?.data || err.message);
            displayMsg("Error al enviar el reporte. Intente de nuevo.", MSG_ERR);
            this.setState({ submitting: false });
        }
    }

    render() {
        const { tasks_by_loc, selected_loc, myLoc, onOpen, getArrowPointingtoLoc, onBack } = this.props;
        const { showReport, incidentType, incidentNotes, submitting } = this.state;

        if (selected_loc < 0 || !tasks_by_loc?.length) return <p>No Data found</p>

        const start = { latitude: myLoc.lat, longitude: myLoc.lon }
        const loc = tasks_by_loc[selected_loc];
        const end = { latitude: loc.loc_lat, longitude: loc.loc_lon }
        const loc_distance = Math.round(haversine(start, end, { unit: 'meter' }))

        return (
            <Fragment>
                {/* Location header */}
                <div className="navbar-light bg-light border-bottom pb-2 mb-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2 flex-grow-1 me-2 overflow-hidden">
                            <h5 className="mb-0 text-truncate">{loc.loc_name}</h5>
                            <img
                                className="image-option-gallery flex-shrink-0"
                                width={24} height={24}
                                src={getArrowPointingtoLoc(end.latitude, end.longitude)}
                                alt="Dirección"
                            />
                        </div>
                        <div className="d-flex flex-column align-items-stretch flex-shrink-0" style={{gap: '10px'}}>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={onBack}
                            >
                                ← Tareas
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-warning btn-sm"
                                onClick={() => this.setState(s => ({ showReport: !s.showReport }))}
                            >
                                ⚠ Problema
                            </button>
                        </div>
                    </div>
                    <div className="small text-muted mt-1">
                        {loc.loc_address} · {loc_distance} mts
                    </div>
                </div>

                {/* Incident report form — inline collapsible */}
                {showReport && (
                    <div className="card border-warning mb-3">
                        <div className="card-body py-2">
                            <h6 className="card-title mb-2 text-warning">Reportar problema con esta ubicación</h6>

                            <div className="mb-2">
                                <label className="form-label small fw-semibold mb-1">Tipo de problema</label>
                                {INCIDENT_TYPES.map(t => (
                                    <div className="form-check" key={t.value}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id={`inc_${t.value}`}
                                            name="incidentType"
                                            value={t.value}
                                            checked={incidentType === t.value}
                                            onChange={e => this.setState({ incidentType: e.target.value })}
                                        />
                                        <label className="form-check-label small" htmlFor={`inc_${t.value}`}>
                                            {t.label}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div className="mb-2">
                                <label className="form-label small fw-semibold mb-1">Notas adicionales (opcional)</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    rows={2}
                                    maxLength={500}
                                    placeholder="Describa brevemente el problema..."
                                    value={incidentNotes}
                                    onChange={e => this.setState({ incidentNotes: e.target.value })}
                                />
                            </div>

                            <div className="d-flex gap-2">
                                <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    onClick={this.submitIncident}
                                    disabled={submitting}
                                >
                                    {submitting ? 'Enviando…' : 'Enviar reporte'}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => this.setState({ showReport: false })}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Survey cards */}
                <div className="row g-2">
                    {loc.loc_surveys.map((svy, index) => (
                        <div className="col-12" key={svy.survey}>
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body d-flex flex-column">
                                    <h6 className="card-title mb-2">{svy.survey_title}</h6>
                                    <p className="card-text small text-muted mb-2 flex-grow-1">
                                        {svy.questions_per_survey} pregunta
                                        {svy.questions_per_survey > 1 ? 's' : ''} por encuesta<br />
                                        {svy.surveys_to_complete - svy.surveys_completed} encuesta
                                        {(svy.surveys_to_complete - svy.surveys_completed) > 1 ? 's' : ''} por completar
                                    </p>
                                    <button
                                        onClick={() => onOpen(index)}
                                        className="btn btn-primary btn-sm align-self-start"
                                    >
                                        Abrir
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Fragment>
        )
    }
}

export default ActivateLoc;
